import { readTabContext, writeTabContext, clearTabContext, getPartnerToken, partnerTokenClaims } from '@/services/auth/partnerSessionStorage';

const PARTNER_SESSION_CACHE_KEY = 'ewu_tpv_partner_session_cache';

function nowIso() {
  return new Date().toISOString();
}

export function savePartnerSessionCache(user) {
  if (!user) return null;

  const displayName = [user.first_name, user.last_name]
    .map((value) => String(value || '').trim())
    .filter(Boolean)
    .join(' ') || user.username || user.email || '';

  const cachedUser = {
    id: user.id || null,
    email: user.email || null,
    username: user.username || null,
    first_name: user.first_name || '',
    last_name: user.last_name || '',
    display_name: displayName,
    restaurant_id: user.restaurant_id || user.restaurant?.id || null,
    restaurant_name: user.restaurant_name || user.restaurant?.name || '',
    restaurant_logo: user.restaurant_logo || null,
    is_partner: Boolean(user.is_partner),
    restaurants: Array.isArray(user.restaurants) ? user.restaurants : [],
    subscription_plan: user.subscription_plan || user.restaurant?.subscription_plan || 'ewu_tpv',
    tpv_permissions: Array.isArray(user.tpv_permissions) ? user.tpv_permissions : [],
    user_allowed_to_cancel: Boolean(user.user_allowed_to_cancel),
    cached_at: nowIso(),
  };

  try {
    writeTabContext(PARTNER_SESSION_CACHE_KEY, JSON.stringify(cachedUser));
  } catch (error) {
    console.warn('Unable to save EWU partner session cache:', error);
  }

  return cachedUser;
}

export function getPartnerSessionCache(token = null) {
  try {
    token = token || getPartnerToken();
    const raw = readTabContext(PARTNER_SESSION_CACHE_KEY);
    const cached = raw ? JSON.parse(raw) : null;
    if (!cached || !token) return null;

    // La caché sobrevive a los cambios de cuenta. Solo sirve para permisos
    // si corresponde al usuario del token actual; la API valida el JWT.
    const payload = partnerTokenClaims(token);
    const matchesRestaurant = !payload.restaurant_id || String(cached.restaurant_id) === String(payload.restaurant_id);
    return cached.id && String(cached.id) === String(payload.id) && matchesRestaurant ? cached : null;
  } catch (error) {
    console.warn('Unable to read EWU partner session cache:', error);
    return null;
  }
}

export function clearPartnerSessionCache() {
  try {
    clearTabContext(PARTNER_SESSION_CACHE_KEY);
  } catch (error) {
    console.warn('Unable to clear EWU partner session cache:', error);
  }
}
